import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {DialogRef} from '@progress/kendo-angular-dialog';
import {DtoCustomerReport} from '../models/DtoCustomerReport';
import {DynamicGridComponent} from "../../../../fw/dynamic-grids/dynamic-grid.component";
import {PageSubheaderBarConfig} from "../../../../fw/pages/page-config-api";
import {ColumnDefinition} from "../../../../fw/dynamic-grids/column-definition";
import {SharedService} from "../../../shared/shared.service";
import {MailingService} from "../mailing.service";
import {DtoCustomerFilter} from "../models/DtoCustomerFilter";
import {DialogWrapperComponent} from "../../../../fw/dialog-wrapper/dialog-wrapper.component";
import {DialogWrapperConfig} from "../../../../fw/dialog-wrapper/dialog-wrapper-config";

@Component({
    selector: 'customer-overview-add',
    template: require('./mailing-add.component.html'),
    styles: [require('./mailing-add.component.css')]
})

export class MailingAddComponent implements OnInit, OnDestroy {
    @Input() dialog: DialogRef;
    @Output() chosenCustomer = new EventEmitter<DtoCustomerReport>();
    @ViewChild('grid', {static: false}) grid: DynamicGridComponent;
    @ViewChild('dialogWrapper', {static: true}) dialogWrapper: DialogWrapperComponent;

    wrapperConfig: DialogWrapperConfig = {
        title: [
            {
                text:'KLANTEN',
                isLastStep: false
            },
            {
                text:'KLANTEN OVERZICHT',
                isLastStep: false
            },
            {
                text:'KLANT TOEVOEGEN',
                isLastStep: true
            }
        ],
        buttonDefinition: [
            {
                clickEventType: 'search',
                description:'ZOEKEN',
                isSmall: false
            },
            {
                clickEventType: 'clear',
                description:'LEEGMAKEN',
                isSmall: false
            }
        ]
    };
    filterForm: FormGroup = this.fb.group({
        firstname: null,
        zipcode: null,
        customerNo: null,
        phoneNo: null,
        lastname: null,
        city: null,
        birthdate: null,
        email: null
    });
    pshbConfig: PageSubheaderBarConfig = {
        title:'KLANTEN',
        buttonDefinition: [
            {
                clickEventType: 'select',
                description:'SELECTEREN',
                isSmall: false
            },
            {
                clickEventType: 'cancel',
                description:'ANNULEREN',
                isSmall: false
            }
        ]
    };
    data: DtoCustomerReport[];
    columnDefinition: ColumnDefinition[] = [
        {
            key: 'customerNo',
            label:'Klantnr.',
            type: 'number',
            width: '120px'
        },
        {
            key: 'name',
            label:'Naam',
            type: 'string',
            width: '*'
        },
        {
            key: 'zipcode',
            label:'Postcode',
            type: 'string',
            width: '100px'
        },
        {
            key: 'birthdate',
            label:'Geboortedatum',
            type: 'string',
            width: '130px',
            format: '{0:dd-MM-yyyy}'
        },
        {
            key: 'gender',
            label:'M/V',
            type: 'string',
            width: '70px'
        }
    ];

    constructor(
        private fb: FormBuilder,
        public ds: MailingService,
        public ss: SharedService
    ) {
    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }

    loadData() {
        let filter = {} as DtoCustomerFilter;
        filter.showProfilePicture = true;
        filter.firstName = this.filterForm.value.firstname;
        filter.zipcode = this.filterForm.value.zipcode;
        filter.customerNo = this.filterForm.value.customerNo;
        filter.phoneNo = this.filterForm.value.phoneNo;
        filter.lastName = this.filterForm.value.lastname;
        filter.city = this.filterForm.value.city;
        filter.birthDate = this.filterForm.value.birthdate;
        filter.email = this.filterForm.value.email;

        this.ds
            .searchCustomerForReport(filter).subscribe((res: DtoCustomerReport[]) => {
                this.data = res;
                this.grid.showData(this.data);
            });
    }

    phbBtnClicked(event) {
        if (event == 'search') {
            this.loadData();
        } else if (event == 'clear') {
            this.filterClear();
        }
    }

    filterClear() {
        this.filterForm.reset();
        if (this.grid) this.grid.clearData();
    }

    onFilterEnter(event) {
        event.target.blur();
        this.loadData();
    }

    onFilterEsc(event) {
        this.filterClear();
    }

    pshbBtnClicked(event) {
        if (event == 'select') {
            this.setSelectedCustomer();
        } else if (event == 'cancel') {
            this.closeWindow(false);
        }
    }

    gridRowdoubleClicked(event) {
        this.setSelectedCustomer();
    }

    setSelectedCustomer() {
        if (this.grid.getSelectedId() > 0) {
            this.chosenCustomer.emit(this.grid.getSelectedItem());
            this.closeWindow(true);
        }
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialogWrapper.dialogResult.emit({reload: result});
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/marketing/mailing/dialogs/mailing-add.component.ts